import NotFound from "./not_found.png";
import backGround from "./background.png";
import logoFull from "./logo_full.png";
import paypal from './paypal.png'
import support from './support.png'
import supportLogo from './support_logo.png'
import directionBgr from './directionBgr.png'

const IMAGE = {
  NotFound: NotFound,
  backGround: backGround,
  logoFull: logoFull,
  paypal,
  support, 
  supportLogo,
  directionBgr
};

export default IMAGE;
